// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!./BDT_global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BDT_Bus_txt-primary__xfCMW {
  color: var(--text-color-1);
}

.BDT_Bus_txt-secondary__4vPh1 {
  color: var(--text-color-2);
}

/* form-label_bus */
/* .font-bus-head {
    font-size: 16px !important;
    font-weight: bolder;
    color: #000;
} */
.BDT_Bus_font_bus_head__l5br9 {
  font-size: 16px !important;
  font-weight: bolder;
  color: #000;
}

/* widget_Bus */
/* .bg-light-blue {
    background: var(--card-bg-color)
} */
.BDT_Bus_bg_light_blue__tP45H {
  background: var(--card-bg-color);
}

/* .body-bg-color {
    background-color: #F2F3FC !important;
} */
.BDT_Bus_body_bg_color__4k0Ne {
  background-color: #f2f3fc !important;
  height: 100vh;
  overflow-y: auto;
}

.BDT_Bus_widgetIcon__mpvhY img {
  width: 70px;
  height: 70px;
}

/* .bold-text {
    font-weight: bold;
    color: black;
    font-size: 14px !important
} */
.BDT_Bus_bold_text__tRvvI {
  font-weight: bold;
  color: black;
  font-size: 14px !important;
}

/* .bdt-table td {
    padding: 3px !important
} */

.BDT_Bus_bdt_table__wRo7j td {
  padding: 3px !important;
}

.BDT_Bus_bdt_table__wRo7j {
  max-height: 20rem;
  overflow-y: scroll;
}

.BDT_Bus_bdt_table__wRo7j::-webkit-scrollbar {
  width: 0px;
  height: 1px;
}

/* .bolder-text {
    font-weight: bolder;
    color: black;
    font-size: 22px !important
} */
.BDT_Bus_bolder_text__PjHjR {
  font-weight: bolder;
  color: black;
  font-size: 22px !important;
}

/* .table-label-container {
    font-size: 1em;
    color: var(--text-color-2);
    font-weight: 600;
    margin-bottom: 10px;
    border-radius: 5px 5px 0 0;
    margin-top: -12px;
} */

.BDT_Bus_table_label_container__CkuhH {
  font-size: 1em;
  color: var(--text-color-2);
  font-weight: 600;
  margin-bottom: 10px;
  border-radius: 5px 5px 0 0;
  margin-top: -12px;
}

/* .BDT-badge {
    color: var(--text-color-1);
    width: auto;
    background-color: var(--primary-bg-color);
    padding: 6px 10px;
    font-size: 10px
} */

.BDT_Bus_BDT_badge__-kVfm {
  color: var(--text-color-1);
  width: auto;
  background-color: var(--primary-bg-color);
  padding: 6px 10px;
  font-size: 10px;
}

/* .hover-button {
    visibility: hidden;
} */

.BDT_Bus_hover_button__QJtCx {
  visibility: hidden;
}

tr:hover .BDT_Bus_hover-button__ihbMO {
  visibility: visible;
}

/* .table-card {
    background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    min-height: 293px;
} */

.BDT_Bus_table_card__7W8-n {
  background: #ffffff;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  padding: 10px;
  color: #353535;
  min-height: 293px;
}

/* .form-select:focus {
    border-color: #358696;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);
} */

.BDT_Bus_form_select__BqiXl:focus {
  border-color: #358696;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);
}

/* .cursor-pointer:hover {
    color: blue;
} */

.BDT_Bus_cursor_pointer__ncXxZ:hover {
  color: blue;
}

.BDT_Bus_cursor_pointer__ncXxZ {
  cursor: pointer !important;
}

/* BDT filter classes Starts */

/* .solid-border {
    border: 1px solid #a5b0a9 !important;
    border-radius: 6px;
} */
.BDT_Bus_solid_border__J21fD {
  border: 1px solid #a5b0a9 !important;
  border-radius: 6px;
}

/* FilterDiv_bus */
/* .bg-filter {
    background-color: var(--primary-bg-color) !important;
} */
.BDT_Bus_bg_filter__kr-Nk {
  background-color: var(--primary-bg-color) !important;
}

.BDT_Bus_filterForm__eeuS0 > .BDT_Bus_form-label__awlvs {
  font-size: 0.825em;
}

/* form-label_bus */
/* .form-text-label {
    background: transparent;
    padding: 0px !important;
    text-align: left;
    margin-bottom: 0px !important;
    color: var(--text-color-1) !important;
    font-weight: 600;
    display: block;
} */

.BDT_Bus_form_text_label__va9vB {
  /* color: #83a4cf !important; */
  background: transparent;
  padding: 0px !important;
  text-align: left;
  margin-bottom: 0px !important;
  color: var(--text-color-1) !important;
  font-weight: 600;
  display: block;
}

.BDT_Bus_bus_filtr_btn__VWJLK {
  position: relative;
  top: 10px;
}

/* BDT filter classes End */

.BDT_Bus_body-color-BDT__S-T5X {
  background-color: #f2f3fc !important;
  margin: -3px;
}

.BDT_Bus_body_color_BDT__MI0pz {
  background-color: #f2f3fc !important;
  margin: -3px;
}

.BDT_Bus_btn_outline_primary_BDT__G6m4n {
  /* color: #d59e8a !important; */
  border-color: #879db2;
}

.BDT_Bus_btn_outline_primary_BDT__G6m4n:hover,
.BDT_Bus_btn_outline_primary_BDT__G6m4n:focus,
.BDT_Bus_btn_outline_primary_BDT__G6m4n:visited,
.BDT_Bus_btn_outline_primary_BDT__G6m4n:active,
.BDT_Bus_btn-check__SMTr\\+:checked + .BDT_Bus_btn__-Ne6x,
.BDT_Bus_btn__-Ne6x.BDT_Bus_active__fw6J-,
.BDT_Bus_btn__-Ne6x.BDT_Bus_show__RbgVW,
.BDT_Bus_btn__-Ne6x:first-child:active,
:not(.BDT_Bus_btn-check__SMTr\\+) + .BDT_Bus_btn__-Ne6x:active {
  background-color: #83a4cf !important;
  color: #1e4199;
}

/* button primary  */

.BDT_Bus_btn_primary_BDT__1BP-u {
  background-color: #83a4cf !important;
  border-color: #83a4cf !important;
  color: #fff !important;
}

.BDT_Bus_btn_primary_BDT__1BP-u:hover,
.BDT_Bus_btn_primary_BDT__1BP-u:focus,
.BDT_Bus_btn_primary_BDT__1BP-u:visited,
.BDT_Bus_btn_primary_BDT__1BP-u:active,
.BDT_Bus_btn-check__SMTr\\+:checked + .BDT_Bus_btn__-Ne6x,
.BDT_Bus_btn__-Ne6x.BDT_Bus_active__fw6J-,
.BDT_Bus_btn__-Ne6x.BDT_Bus_show__RbgVW,
.BDT_Bus_btn__-Ne6x:first-child:active,
:not(.BDT_Bus_btn-check__SMTr\\+) + .BDT_Bus_btn__-Ne6x:active {
  color: #fff !important;
  background-color: #83a4cf96 !important;
  border-color: #83a4cf96 !important;
}

.BDT_Bus_btn_secondary_BDT__Yjd5s {
  color: #fff;
  background: #7b7878 !important;
  border: silver;
}

.BDT_Bus_btn_secondary_BDT__Yjd5s:hover,
.BDT_Bus_btn_secondary_BDT__Yjd5s:focus,
.BDT_Bus_btn_secondary_BDT__Yjd5s:visited,
.BDT_Bus_btn_secondary_BDT__Yjd5s:active,
.BDT_Bus_btn-check__SMTr\\+:checked + .BDT_Bus_btn__-Ne6x,
.BDT_Bus_btn__-Ne6x.BDT_Bus_active__fw6J-,
.BDT_Bus_btn__-Ne6x.BDT_Bus_show__RbgVW,
.BDT_Bus_btn__-Ne6x:first-child:active,
:not(.BDT_Bus_btn-check__SMTr\\+) + .BDT_Bus_btn__-Ne6x:active {
  color: #fff !important;
  background-color: #83a4cf96 !important;
  border-color: #83a4cf96 !important;
}

.BDT_Bus_soh_heading__MH1Xw {
  background-color: #e0e0e0;
  font-size: 1rem;
  padding: 2px;
  font-weight: bolder;
  color: #0e3157;
}

.BDT_Bus_card_height__iJIAO {
  height: 19rem;
}

.BDT_Bus_pack_sticky__xbGz\\+ {
  position: sticky;
  top: 0;
  z-index: 1000;
}
.BDT_Bus_headingBDT__38DmJ {
  font-size: 18px;
  font-weight: bolder;
  color: #112455;
}

.BDT_Bus_packBar__Qn3go {
  position: sticky; /* or fixed if you want */
  left: 0;
  z-index: 1;

  display: flex;
  align-items: center;
  margin:2px 0 0 18px;
  width: 76px; /* collapsed width */
  overflow: hidden;
  transition: width 0.3s ease;
  font-weight: bolder;
}

/* collapsed view */
.BDT_Bus_selectedPack__alV4M {

  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  background-color: #ccc7c7;
  border-radius: 5px;
  padding: 2px 3px;
  color:#0e3157;

}

/* arrow */
.BDT_Bus_arrow__bmc8i {
  font-weight: bold;
  opacity: 0.7;
}

/* options (hidden initially) */
.BDT_Bus_packOptions__TdMLJ {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-left: 14px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

/* expand to RIGHT */
.BDT_Bus_packBar__Qn3go:hover {
  width: 350px;
}

/* show options */
.BDT_Bus_packBar__Qn3go:hover .BDT_Bus_packOptions__TdMLJ {
  opacity: 1;
  pointer-events: auto;
}

/* radio cleanup */
.BDT_Bus_option__slt73 input {
  display: none;
}

.BDT_Bus_option__slt73 {
  cursor: pointer;
  white-space: nowrap;
}


`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/BatteryDigitalTwin_Bus/BDT_Bus.module.css"],"names":[],"mappings":"AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;;;;GAIG;AACH;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;AACb;;AAEA,eAAe;AACf;;GAEG;AACH;EACE,gCAAgC;AAClC;;AAEA;;GAEG;AACH;EACE,oCAAoC;EACpC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;GAIG;AACH;EACE,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;;GAEG;;AAEH;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;;;GAIG;AACH;EACE,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;;;;;;;GAOG;;AAEH;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;;;;;GAMG;;AAEH;EACE,0BAA0B;EAC1B,WAAW;EACX,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;GAMG;;AAEH;EACE,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;GAIG;;AAEH;EACE,qBAAqB;EACrB,UAAU;EACV,+CAA+C;AACjD;;AAEA;;GAEG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8BAA8B;;AAE9B;;;GAGG;AACH;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;;GAEG;AACH;EACE,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;;;;;;;;GAQG;;AAEH;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA,2BAA2B;;AAE3B;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;;;;;;;;EASE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,oBAAoB;;AAEpB;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;;;;;;;;EASE,sBAAsB;EACtB,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;;;;;;;;EASE,sBAAsB;EACtB,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,OAAO;EACP,UAAU;;EAEV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW,EAAE,oBAAoB;EACjC,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;;AAEf;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB","sourcesContent":["@import url('BDT_global.css');\n\n.txt-primary {\n  color: var(--text-color-1);\n}\n\n.txt-secondary {\n  color: var(--text-color-2);\n}\n\n/* form-label_bus */\n/* .font-bus-head {\n    font-size: 16px !important;\n    font-weight: bolder;\n    color: #000;\n} */\n.font_bus_head {\n  font-size: 16px !important;\n  font-weight: bolder;\n  color: #000;\n}\n\n/* widget_Bus */\n/* .bg-light-blue {\n    background: var(--card-bg-color)\n} */\n.bg_light_blue {\n  background: var(--card-bg-color);\n}\n\n/* .body-bg-color {\n    background-color: #F2F3FC !important;\n} */\n.body_bg_color {\n  background-color: #f2f3fc !important;\n  height: 100vh;\n  overflow-y: auto;\n}\n\n.widgetIcon img {\n  width: 70px;\n  height: 70px;\n}\n\n/* .bold-text {\n    font-weight: bold;\n    color: black;\n    font-size: 14px !important\n} */\n.bold_text {\n  font-weight: bold;\n  color: black;\n  font-size: 14px !important;\n}\n\n/* .bdt-table td {\n    padding: 3px !important\n} */\n\n.bdt_table td {\n  padding: 3px !important;\n}\n\n.bdt_table {\n  max-height: 20rem;\n  overflow-y: scroll;\n}\n\n.bdt_table::-webkit-scrollbar {\n  width: 0px;\n  height: 1px;\n}\n\n/* .bolder-text {\n    font-weight: bolder;\n    color: black;\n    font-size: 22px !important\n} */\n.bolder_text {\n  font-weight: bolder;\n  color: black;\n  font-size: 22px !important;\n}\n\n/* .table-label-container {\n    font-size: 1em;\n    color: var(--text-color-2);\n    font-weight: 600;\n    margin-bottom: 10px;\n    border-radius: 5px 5px 0 0;\n    margin-top: -12px;\n} */\n\n.table_label_container {\n  font-size: 1em;\n  color: var(--text-color-2);\n  font-weight: 600;\n  margin-bottom: 10px;\n  border-radius: 5px 5px 0 0;\n  margin-top: -12px;\n}\n\n/* .BDT-badge {\n    color: var(--text-color-1);\n    width: auto;\n    background-color: var(--primary-bg-color);\n    padding: 6px 10px;\n    font-size: 10px\n} */\n\n.BDT_badge {\n  color: var(--text-color-1);\n  width: auto;\n  background-color: var(--primary-bg-color);\n  padding: 6px 10px;\n  font-size: 10px;\n}\n\n/* .hover-button {\n    visibility: hidden;\n} */\n\n.hover_button {\n  visibility: hidden;\n}\n\ntr:hover .hover-button {\n  visibility: visible;\n}\n\n/* .table-card {\n    background: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    padding: 10px;\n    color: #353535;\n    min-height: 293px;\n} */\n\n.table_card {\n  background: #ffffff;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  padding: 10px;\n  color: #353535;\n  min-height: 293px;\n}\n\n/* .form-select:focus {\n    border-color: #358696;\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);\n} */\n\n.form_select:focus {\n  border-color: #358696;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);\n}\n\n/* .cursor-pointer:hover {\n    color: blue;\n} */\n\n.cursor_pointer:hover {\n  color: blue;\n}\n\n.cursor_pointer {\n  cursor: pointer !important;\n}\n\n/* BDT filter classes Starts */\n\n/* .solid-border {\n    border: 1px solid #a5b0a9 !important;\n    border-radius: 6px;\n} */\n.solid_border {\n  border: 1px solid #a5b0a9 !important;\n  border-radius: 6px;\n}\n\n/* FilterDiv_bus */\n/* .bg-filter {\n    background-color: var(--primary-bg-color) !important;\n} */\n.bg_filter {\n  background-color: var(--primary-bg-color) !important;\n}\n\n.filterForm > .form-label {\n  font-size: 0.825em;\n}\n\n/* form-label_bus */\n/* .form-text-label {\n    background: transparent;\n    padding: 0px !important;\n    text-align: left;\n    margin-bottom: 0px !important;\n    color: var(--text-color-1) !important;\n    font-weight: 600;\n    display: block;\n} */\n\n.form_text_label {\n  /* color: #83a4cf !important; */\n  background: transparent;\n  padding: 0px !important;\n  text-align: left;\n  margin-bottom: 0px !important;\n  color: var(--text-color-1) !important;\n  font-weight: 600;\n  display: block;\n}\n\n.bus_filtr_btn {\n  position: relative;\n  top: 10px;\n}\n\n/* BDT filter classes End */\n\n.body-color-BDT {\n  background-color: #f2f3fc !important;\n  margin: -3px;\n}\n\n.body_color_BDT {\n  background-color: #f2f3fc !important;\n  margin: -3px;\n}\n\n.btn_outline_primary_BDT {\n  /* color: #d59e8a !important; */\n  border-color: #879db2;\n}\n\n.btn_outline_primary_BDT:hover,\n.btn_outline_primary_BDT:focus,\n.btn_outline_primary_BDT:visited,\n.btn_outline_primary_BDT:active,\n.btn-check:checked + .btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check) + .btn:active {\n  background-color: #83a4cf !important;\n  color: #1e4199;\n}\n\n/* button primary  */\n\n.btn_primary_BDT {\n  background-color: #83a4cf !important;\n  border-color: #83a4cf !important;\n  color: #fff !important;\n}\n\n.btn_primary_BDT:hover,\n.btn_primary_BDT:focus,\n.btn_primary_BDT:visited,\n.btn_primary_BDT:active,\n.btn-check:checked + .btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check) + .btn:active {\n  color: #fff !important;\n  background-color: #83a4cf96 !important;\n  border-color: #83a4cf96 !important;\n}\n\n.btn_secondary_BDT {\n  color: #fff;\n  background: #7b7878 !important;\n  border: silver;\n}\n\n.btn_secondary_BDT:hover,\n.btn_secondary_BDT:focus,\n.btn_secondary_BDT:visited,\n.btn_secondary_BDT:active,\n.btn-check:checked + .btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check) + .btn:active {\n  color: #fff !important;\n  background-color: #83a4cf96 !important;\n  border-color: #83a4cf96 !important;\n}\n\n.soh_heading {\n  background-color: #e0e0e0;\n  font-size: 1rem;\n  padding: 2px;\n  font-weight: bolder;\n  color: #0e3157;\n}\n\n.card_height {\n  height: 19rem;\n}\n\n.pack_sticky {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n.headingBDT {\n  font-size: 18px;\n  font-weight: bolder;\n  color: #112455;\n}\n\n.packBar {\n  position: sticky; /* or fixed if you want */\n  left: 0;\n  z-index: 1;\n\n  display: flex;\n  align-items: center;\n  margin:2px 0 0 18px;\n  width: 76px; /* collapsed width */\n  overflow: hidden;\n  transition: width 0.3s ease;\n  font-weight: bolder;\n}\n\n/* collapsed view */\n.selectedPack {\n\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n  background-color: #ccc7c7;\n  border-radius: 5px;\n  padding: 2px 3px;\n  color:#0e3157;\n\n}\n\n/* arrow */\n.arrow {\n  font-weight: bold;\n  opacity: 0.7;\n}\n\n/* options (hidden initially) */\n.packOptions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  margin-left: 14px;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n}\n\n/* expand to RIGHT */\n.packBar:hover {\n  width: 350px;\n}\n\n/* show options */\n.packBar:hover .packOptions {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n/* radio cleanup */\n.option input {\n  display: none;\n}\n\n.option {\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"txt-primary": `BDT_Bus_txt-primary__xfCMW`,
	"txt-secondary": `BDT_Bus_txt-secondary__4vPh1`,
	"font_bus_head": `BDT_Bus_font_bus_head__l5br9`,
	"bg_light_blue": `BDT_Bus_bg_light_blue__tP45H`,
	"body_bg_color": `BDT_Bus_body_bg_color__4k0Ne`,
	"widgetIcon": `BDT_Bus_widgetIcon__mpvhY`,
	"bold_text": `BDT_Bus_bold_text__tRvvI`,
	"bdt_table": `BDT_Bus_bdt_table__wRo7j`,
	"bolder_text": `BDT_Bus_bolder_text__PjHjR`,
	"table_label_container": `BDT_Bus_table_label_container__CkuhH`,
	"BDT_badge": `BDT_Bus_BDT_badge__-kVfm`,
	"hover_button": `BDT_Bus_hover_button__QJtCx`,
	"hover-button": `BDT_Bus_hover-button__ihbMO`,
	"table_card": `BDT_Bus_table_card__7W8-n`,
	"form_select": `BDT_Bus_form_select__BqiXl`,
	"cursor_pointer": `BDT_Bus_cursor_pointer__ncXxZ`,
	"solid_border": `BDT_Bus_solid_border__J21fD`,
	"bg_filter": `BDT_Bus_bg_filter__kr-Nk`,
	"filterForm": `BDT_Bus_filterForm__eeuS0`,
	"form-label": `BDT_Bus_form-label__awlvs`,
	"form_text_label": `BDT_Bus_form_text_label__va9vB`,
	"bus_filtr_btn": `BDT_Bus_bus_filtr_btn__VWJLK`,
	"body-color-BDT": `BDT_Bus_body-color-BDT__S-T5X`,
	"body_color_BDT": `BDT_Bus_body_color_BDT__MI0pz`,
	"btn_outline_primary_BDT": `BDT_Bus_btn_outline_primary_BDT__G6m4n`,
	"btn-check": `BDT_Bus_btn-check__SMTr+`,
	"btn": `BDT_Bus_btn__-Ne6x`,
	"active": `BDT_Bus_active__fw6J-`,
	"show": `BDT_Bus_show__RbgVW`,
	"btn_primary_BDT": `BDT_Bus_btn_primary_BDT__1BP-u`,
	"btn_secondary_BDT": `BDT_Bus_btn_secondary_BDT__Yjd5s`,
	"soh_heading": `BDT_Bus_soh_heading__MH1Xw`,
	"card_height": `BDT_Bus_card_height__iJIAO`,
	"pack_sticky": `BDT_Bus_pack_sticky__xbGz+`,
	"headingBDT": `BDT_Bus_headingBDT__38DmJ`,
	"packBar": `BDT_Bus_packBar__Qn3go`,
	"selectedPack": `BDT_Bus_selectedPack__alV4M`,
	"arrow": `BDT_Bus_arrow__bmc8i`,
	"packOptions": `BDT_Bus_packOptions__TdMLJ`,
	"option": `BDT_Bus_option__slt73`
};
export default ___CSS_LOADER_EXPORT___;
